/* cstx-build: 2026-05-18-social-carousel-autoplay-index */
(function () {
  const accent =
    getComputedStyle(document.body).getPropertyValue('--cstx-hot').trim() || '#FE0000';

  /* Sticky nav */
  const nav = document.querySelector('[data-cstx-nav]');
  if (nav) {
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Metronome pulse */
  document.querySelectorAll('[data-cstx-metronome]').forEach((metroLight) => {
    const bpm = parseInt(metroLight.getAttribute('data-bpm'), 10) || 168;
    setInterval(() => metroLight.classList.toggle('is-on'), 60000 / bpm);
  });

  /* Pro testimonials — mobile show-more reveal */
  document.querySelectorAll('[data-cstx-pro-show-more]').forEach((btn) => {
    if (btn.dataset.cstxProShowBound) return;
    btn.dataset.cstxProShowBound = '1';
    btn.addEventListener('click', () => {
      const grid = btn.previousElementSibling;
      if (grid && grid.classList.contains('cstx-pro-cards')) {
        grid.classList.add('is-expanded');
      }
      btn.classList.add('is-hidden');
    });
  });

  /* Problem columns hover (desktop) */
  document.querySelectorAll('[data-cstx-problem-col]').forEach((col) => {
    col.addEventListener('mouseenter', () => col.classList.add('is-hover'));
    col.addEventListener('mouseleave', () => col.classList.remove('is-hover'));
  });

  /* Problem columns: red-on-scroll spotlight (mobile only) */
  if (window.matchMedia('(max-width: 750px)').matches && 'IntersectionObserver' in window) {
    const probObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-hover', entry.isIntersecting);
      });
    }, { rootMargin: '-30% 0px -30% 0px', threshold: 0 });
    document.querySelectorAll('[data-cstx-problem-col]').forEach((col) => probObserver.observe(col));
  }

  /* Field reports — testimonial carousel */
  document.querySelectorAll('[data-cstx-quotes-carousel]').forEach((root) => {
    if (root.dataset.cstxQuotesBound) return;
    root.dataset.cstxQuotesBound = '1';

    const viewport = root.querySelector('[data-cstx-quotes-viewport]');
    const prevBtn = root.querySelector('[data-cstx-quotes-prev]');
    const nextBtn = root.querySelector('[data-cstx-quotes-next]');
    const dotsRoot = root.querySelector('[data-cstx-quotes-dots]');
    if (!viewport) return;

    const slides = () => Array.from(viewport.querySelectorAll(':scope > .cstx-quote'));
    if (slides().length < 2) return;

    function gapPx() {
      const g = getComputedStyle(viewport).gap;
      const n = parseFloat(g);
      return Number.isFinite(n) ? n : 24;
    }

    function scrollOffsetForIndex(i) {
      const list = slides();
      const idx = Math.max(0, Math.min(list.length - 1, i));
      let left = 0;
      for (let j = 0; j < idx; j++) {
        left += list[j].offsetWidth + gapPx();
      }
      return left;
    }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function scrollToIndex(i, instant) {
      const behavior = instant || prefersReducedMotion() ? 'auto' : 'smooth';
      viewport.scrollTo({ left: scrollOffsetForIndex(i), behavior });
    }

    function nearestIndex() {
      const list = slides();
      const w = list[0].offsetWidth + gapPx();
      if (!w) return 0;
      return Math.min(list.length - 1, Math.max(0, Math.round(viewport.scrollLeft / w)));
    }

    function syncUi() {
      const idx = nearestIndex();
      if (!dotsRoot) return;
      dotsRoot.querySelectorAll('.cstx-quotes-carousel__dot').forEach((dot, di) => {
        const on = di === idx;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    let autoplayTimer = null;
    const ms = parseInt(root.getAttribute('data-autoplay-ms') || '0', 10);
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
    function startAutoplay() {
      stopAutoplay();
      if (ms < 1000 || prefersReducedMotion()) return;
      autoplayTimer = window.setInterval(() => {
        const list = slides();
        const n = list.length;
        const i = nearestIndex();
        scrollToIndex(i >= n - 1 ? 0 : i + 1);
      }, ms);
    }

    function step(delta) {
      stopAutoplay();
      const n = slides().length;
      const i = nearestIndex();
      const next = (i + delta + n) % n;
      scrollToIndex(next);
    }

    if (dotsRoot) {
      dotsRoot.innerHTML = '';
      slides().forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cstx-quotes-carousel__dot';
        b.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
        b.addEventListener('click', () => {
          stopAutoplay();
          scrollToIndex(i);
        });
        dotsRoot.appendChild(b);
      });
    }

    prevBtn?.addEventListener('click', () => step(-1));
    nextBtn?.addEventListener('click', () => step(1));

    const showMoreBtn = root.querySelector('[data-cstx-quotes-show-more]');
    showMoreBtn?.addEventListener('click', () => {
      root.classList.add('is-expanded');
    });

    viewport.addEventListener('scroll', syncUi, { passive: true });

    viewport.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        step(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        step(1);
      }
    });

    const ro = new ResizeObserver(() => syncUi());
    ro.observe(viewport);

    viewport.addEventListener('pointerdown', stopAutoplay, { passive: true });
    root.addEventListener('mouseenter', stopAutoplay);

    syncUi();
    startAutoplay();
  });

  /* Social feed — reel carousel */
  document.querySelectorAll('[data-cstx-social-carousel]').forEach((root) => {
    if (root.dataset.cstxSocialBound) return;
    root.dataset.cstxSocialBound = '1';

    const viewport = root.querySelector('[data-cstx-social-viewport]');
    const track = viewport && viewport.querySelector('[data-cstx-social-track]');
    const prevBtn = root.querySelector('[data-cstx-social-prev]');
    const nextBtn = root.querySelector('[data-cstx-social-next]');
    const dotsRoot = root.querySelector('[data-cstx-social-dots]');
    if (!viewport) return;

    const slides = () =>
      Array.from((track || viewport).querySelectorAll(':scope > .cstx-social-carousel__slide'));
    if (slides().length < 2) return;

    let currentIndex = 0;

    function viewportCanScroll() {
      return viewport.scrollWidth > viewport.clientWidth + 1;
    }

    function useTransformMode() {
      return Boolean(track) && !viewportCanScroll();
    }

    function gapPx() {
      const el = track || viewport;
      const g = getComputedStyle(el).gap;
      const n = parseFloat(g);
      return Number.isFinite(n) ? n : 20;
    }

    function scrollOffsetForIndex(i) {
      const list = slides();
      const idx = Math.max(0, Math.min(list.length - 1, i));
      let left = 0;
      const gap = gapPx();
      for (let j = 0; j < idx; j++) {
        left += list[j].offsetWidth + gap;
      }
      return left;
    }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function nearestIndexFromScroll() {
      const list = slides();
      const w = list[0].offsetWidth + gapPx();
      if (!w) return 0;
      return Math.min(list.length - 1, Math.max(0, Math.round(viewport.scrollLeft / w)));
    }

    function reconcileMode() {
      if (useTransformMode()) {
        root.setAttribute('data-cstx-social-use-transform', '1');
        viewport.scrollLeft = 0;
        const list = slides();
        const idx = Math.max(0, Math.min(list.length - 1, currentIndex));
        currentIndex = idx;
        if (track && list.length) {
          const step = list[0].offsetWidth + gapPx();
          const x = -idx * step;
          track.style.transition = 'none';
          track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
        }
      } else {
        root.removeAttribute('data-cstx-social-use-transform');
        if (track) {
          track.style.transform = '';
          track.style.transition = '';
        }
        viewport.scrollTo({ left: scrollOffsetForIndex(currentIndex), behavior: 'auto' });
      }
    }

    function goToIndex(i, instant) {
      const list = slides();
      const idx = Math.max(0, Math.min(list.length - 1, i));
      currentIndex = idx;
      if (useTransformMode() && track) {
        viewport.scrollLeft = 0;
        const step = list[0].offsetWidth + gapPx();
        const x = -idx * step;
        const instantEff = instant || prefersReducedMotion();
        track.style.transition = instantEff
          ? 'none'
          : 'transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)';
        track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      } else {
        if (track) {
          track.style.transform = '';
          track.style.transition = '';
        }
        root.removeAttribute('data-cstx-social-use-transform');
        const behavior = instant || prefersReducedMotion() ? 'auto' : 'smooth';
        viewport.scrollTo({ left: scrollOffsetForIndex(idx), behavior });
      }
      syncUi();
    }

    function syncUi() {
      const idx = currentIndex;
      const list = slides();
      list.forEach((slide, si) => {
        slide.classList.toggle('is-cstx-social-current', si === idx);
      });
      if (!dotsRoot) return;
      dotsRoot.querySelectorAll('.cstx-social-carousel__dot').forEach((dot, di) => {
        const on = di === idx;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    const ms = parseInt(root.getAttribute('data-autoplay-ms') || '0', 10);
    let autoplayTimer = null;
    let resumeTimer = null;
    let scrollEndTimer = null;

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      clearTimeout(resumeTimer);
      resumeTimer = null;
      if (ms < 1000 || prefersReducedMotion()) return;
      autoplayTimer = window.setInterval(() => {
        const list = slides();
        const n = list.length;
        const next = (currentIndex + 1) % n;
        goToIndex(next);
      }, ms);
    }

    function pauseAndMaybeResume() {
      stopAutoplay();
      clearTimeout(resumeTimer);
      resumeTimer = null;
      if (ms < 1000 || prefersReducedMotion()) return;
      resumeTimer = window.setTimeout(() => {
        resumeTimer = null;
        startAutoplay();
      }, 2400);
    }

    function clearPendingResume() {
      clearTimeout(resumeTimer);
      resumeTimer = null;
    }

    function step(delta) {
      stopAutoplay();
      clearPendingResume();
      const n = slides().length;
      const next = (currentIndex + delta + n) % n;
      goToIndex(next);
      pauseAndMaybeResume();
    }

    if (dotsRoot) {
      dotsRoot.innerHTML = '';
      slides().forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cstx-social-carousel__dot';
        b.setAttribute('aria-label', 'Go to feed post ' + (i + 1));
        b.addEventListener('click', () => {
          stopAutoplay();
          clearPendingResume();
          goToIndex(i);
          pauseAndMaybeResume();
        });
        dotsRoot.appendChild(b);
      });
    }

    prevBtn?.addEventListener('click', () => step(-1));
    nextBtn?.addEventListener('click', () => step(1));

    viewport.addEventListener('scroll', () => {
      if (!useTransformMode()) {
        currentIndex = nearestIndexFromScroll();
      }
      syncUi();
      stopAutoplay();
      clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(() => {
        scrollEndTimer = null;
        pauseAndMaybeResume();
      }, 420);
    }, { passive: true });

    viewport.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        step(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        step(1);
      }
    });

    const ro = new ResizeObserver(() => {
      reconcileMode();
      syncUi();
      if (
        ms >= 1000 &&
        !prefersReducedMotion() &&
        !root.matches(':hover') &&
        !root.contains(document.activeElement)
      ) {
        startAutoplay();
      }
    });
    ro.observe(viewport);

    root.addEventListener('mouseenter', () => {
      stopAutoplay();
      clearPendingResume();
    });
    root.addEventListener('mouseleave', () => {
      if (ms >= 1000 && !prefersReducedMotion()) startAutoplay();
    });

    root.addEventListener('focusin', () => {
      stopAutoplay();
      clearPendingResume();
    });
    root.addEventListener('focusout', (e) => {
      if (
        !root.contains(e.relatedTarget) &&
        ms >= 1000 &&
        !prefersReducedMotion()
      ) {
        startAutoplay();
      }
    });

    root.addEventListener('pointerdown', () => {
      stopAutoplay();
      clearPendingResume();
    }, { passive: true });
    root.addEventListener('pointerup', () => pauseAndMaybeResume(), { passive: true });
    root.addEventListener('pointercancel', () => pauseAndMaybeResume(), { passive: true });

    reconcileMode();
    syncUi();
    startAutoplay();
  });

  /* Resistance level switcher — data from tab buttons */
  document.querySelectorAll('[data-cstx-resistance]').forEach((section) => {
    const levelPanel = section.querySelector('[data-cstx-level-panel]');
    const levelTabs = section.querySelectorAll('[data-cstx-level-tab]');
    const levelCta = section.querySelector('[data-cstx-level-cta]');
    const levelForm = section.querySelector('[data-cstx-level-form]');
    const levelVariant = section.querySelector('[data-cstx-level-variant]');

    function setLevel(tab) {
      if (!tab || !levelPanel) return;
      levelTabs.forEach((t) => t.classList.toggle('is-active', t === tab));
      const color = tab.getAttribute('data-color') || accent;
      const name = tab.getAttribute('data-name') || '';
      const grams = tab.getAttribute('data-grams') || '';
      const bpm = tab.getAttribute('data-bpm') || '';
      const desc = tab.getAttribute('data-desc') || '';
      const rec = tab.getAttribute('data-rec') || '';
      const time = tab.getAttribute('data-time') || '';
      const width = tab.getAttribute('data-width') || '33%';
      const variantId = tab.getAttribute('data-variant-id');
      const price = tab.getAttribute('data-price') || '$39';

      levelPanel.style.setProperty('--level-color', color);
      const gramsEl = levelPanel.querySelector('[data-level-grams]');
      const bpmEl = levelPanel.querySelector('[data-level-bpm]');
      const descEl = levelPanel.querySelector('[data-level-desc]');
      const recEl = levelPanel.querySelector('[data-level-rec]');
      const timeEl = levelPanel.querySelector('[data-level-time]');
      const fill = levelPanel.querySelector('[data-level-gauge]');
      if (gramsEl) gramsEl.textContent = grams;
      if (bpmEl) bpmEl.textContent = bpm;
      if (descEl) descEl.textContent = desc;
      if (recEl) recEl.textContent = rec;
      if (timeEl) timeEl.textContent = time;
      if (fill) fill.style.width = width;
      if (levelVariant && variantId) levelVariant.value = variantId;
      if (levelCta) {
        levelCta.style.background = color;
        levelCta.style.borderColor = color;
        if (levelCta.tagName === 'BUTTON') {
          levelCta.innerHTML =
            'Add ' +
            name +
            ' pair to cart — ' +
            price +
            ' <svg class="cstx-icon-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
        } else {
          levelCta.textContent = 'Add ' + name + ' pair to cart — ' + price;
        }
      }
    }

    levelTabs.forEach((tab) => tab.addEventListener('click', () => setLevel(tab)));
    if (levelTabs.length) setLevel(levelTabs[0]);
  });

  // #region agent log
  window.__cstxLogs = window.__cstxLogs || [];
  const CSTX_DEBUG_ON = /[?&]cstxdebug=1/.test(window.location.search);
  function cstxEnsurePanel() {
    if (!CSTX_DEBUG_ON) return null;
    let panel = document.getElementById('cstx-debug-panel');
    if (panel) return panel;
    panel = document.createElement('pre');
    panel.id = 'cstx-debug-panel';
    panel.style.cssText = [
      'position:fixed','left:8px','bottom:8px','z-index:99999','max-width:640px','max-height:60vh',
      'overflow:auto','background:rgba(0,0,0,0.9)','color:#0f0','font:11px/1.35 ui-monospace,monospace',
      'padding:10px 12px','border:1px solid #f00','border-radius:6px','white-space:pre-wrap','margin:0',
    ].join(';');
    panel.textContent = 'CSTX debug panel — events:\n';
    document.body.appendChild(panel);
    return panel;
  }
  function cstxDbg(location, message, data, hypothesisId) {
    const entry = {
      sessionId: '6f4fd4',
      runId: 'buy-cart',
      hypothesisId: hypothesisId || null,
      location,
      message,
      data: data || null,
      timestamp: Date.now(),
    };
    window.__cstxLogs.push(entry);
    try { console.log('[CSTX-DBG]', location, message, data); } catch (_) { /* noop */ }
    try {
      const panel = cstxEnsurePanel();
      if (panel) {
        panel.textContent += `\n[${new Date(entry.timestamp).toISOString().slice(11,23)}] ${location} — ${message}\n  ${JSON.stringify(data)}\n`;
        panel.scrollTop = panel.scrollHeight;
      }
    } catch (_) { /* noop */ }
    try {
      const body = new Blob([JSON.stringify(entry)], { type: 'text/plain' });
      if (navigator.sendBeacon) {
        navigator.sendBeacon('http://127.0.0.1:7800/ingest/74b157cc-dc75-45b2-90d1-c85b7a712ccb', body);
      } else {
        fetch('http://127.0.0.1:7800/ingest/74b157cc-dc75-45b2-90d1-c85b7a712ccb', {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(entry),
          mode: 'no-cors',
          keepalive: true,
        }).catch(() => {});
      }
    } catch (_) { /* noop */ }
  }
  // #endregion

  /* Buy quantity selector — updates total, quantity, and variant */
  async function resolveBuyVariant(section) {
    const variantInput = section.querySelector('[data-cstx-buy-variant]');
    // #region agent log
    cstxDbg('chopstx-home.js:resolveBuyVariant:entry', 'resolveBuyVariant called', {
      hasSection: !!section,
      hasVariantInput: !!variantInput,
      variantInputValue: variantInput ? variantInput.value : null,
      productHandleAttr: section ? section.getAttribute('data-product-handle') : null,
    }, 'H5');
    // #endregion
    if (!variantInput) return;
    const tabsForGate = section.querySelectorAll('[data-cstx-qty-tab]');
    if (variantInput.value && tabsForGate.length > 0 && Array.from(tabsForGate).every((t) => t.getAttribute('data-variant-id'))) return;
    try {
      const res = await fetch('/products.json?limit=250');
      const contentType = res.headers.get('content-type') || '';
      // #region agent log
      cstxDbg('chopstx-home.js:resolveBuyVariant:fetch', '/products.json response', {
        status: res.status,
        ok: res.ok,
        contentType,
        url: res.url,
      }, 'H3');
      // #endregion
      if (!res.ok) return;
      let payload;
      try {
        payload = await res.json();
      } catch (parseErr) {
        // #region agent log
        cstxDbg('chopstx-home.js:resolveBuyVariant:jsonParseFail', 'failed to parse products.json', {
          err: String(parseErr),
          contentType,
        }, 'H3');
        // #endregion
        return;
      }
      const products = payload && payload.products;
      // #region agent log
      cstxDbg('chopstx-home.js:resolveBuyVariant:products', 'products.json parsed', {
        productsCount: products ? products.length : 0,
        firstFew: (products || []).slice(0, 5).map((p) => ({
          handle: p.handle,
          title: p.title,
          published_at: p.published_at,
          variantsCount: (p.variants || []).length,
          firstVariant: p.variants && p.variants[0] ? { id: p.variants[0].id, available: p.variants[0].available } : null,
        })),
      }, 'H1');
      // #endregion
      if (!products || !products.length) return;
      const handle = section.getAttribute('data-product-handle');
      let product = products[0];
      if (handle) {
        const match = products.find((p) => p.handle === handle);
        if (match) product = match;
      }
      const variants = product.variants || [];
      if (!variants.length) return;
      const fallback = variants.find((v) => v.available) || variants[0];
      const tabs = section.querySelectorAll('[data-cstx-qty-tab]');
      tabs.forEach((tab, idx) => {
        if (tab.getAttribute('data-variant-id')) return;
        const v = variants[idx] || fallback;
        if (v) tab.setAttribute('data-variant-id', String(v.id));
      });
      const activeTab = section.querySelector('[data-cstx-qty-tab].is-active') || tabs[0];
      if (activeTab) {
        const vid = activeTab.getAttribute('data-variant-id');
        if (vid) variantInput.value = vid;
      }
      // #region agent log
      cstxDbg('chopstx-home.js:resolveBuyVariant:picked', 'picked product + per-tab variants', {
        productHandle: product.handle,
        productTitle: product.title,
        allVariants: variants.map((v) => ({ id: v.id, title: v.title, available: v.available })),
        tabsAfterAssign: Array.from(tabs).map((t) => ({
          label: t.textContent.trim().slice(0, 24),
          variantId: t.getAttribute('data-variant-id'),
        })),
        variantInputValue: variantInput.value,
      }, 'H2');
      // #endregion
      // #region agent log
      cstxDbg('chopstx-home.js:resolveBuyVariant:done', 'variantInput set', {
        newValue: variantInput.value,
      }, 'H5');
      // #endregion
    } catch (err) {
      // #region agent log
      cstxDbg('chopstx-home.js:resolveBuyVariant:fetchThrow', 'fetch threw', { err: String(err) }, 'H3');
      // #endregion
    }
  }

  const buySections = document.querySelectorAll('[data-cstx-buy]');
  // #region agent log
  cstxDbg('chopstx-home.js:bootstrap', 'buy sections found on page', {
    buySectionsCount: buySections.length,
  }, 'H5');
  // #endregion
  buySections.forEach((section) => {
    const qtyTabs = section.querySelectorAll('[data-cstx-qty-tab]');
    const totalEl = section.querySelector('[data-cstx-total]');
    const variantInput = section.querySelector('[data-cstx-buy-variant]');
    const quantityInput = section.querySelector('[data-cstx-buy-quantity]');

    // #region agent log
    cstxDbg('chopstx-home.js:section:init', 'buy section initialized', {
      qtyTabsCount: qtyTabs.length,
      qtyTabsVariantIds: Array.from(qtyTabs).map((t) => t.getAttribute('data-variant-id')),
      qtyTabsActive: Array.from(qtyTabs).map((t) => t.classList.contains('is-active')),
      variantInputInitialValue: variantInput ? variantInput.value : null,
      hasForm: !!section.querySelector('[data-cstx-buy-form]'),
    }, 'H4');
    // #endregion

    resolveBuyVariant(section);

    function selectTab(tab) {
      if (!tab) return;
      qtyTabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle('is-active', on);
        const shell = t.closest('.cstx-qty-tab-shell');
        if (shell) shell.classList.toggle('is-tab-active', on);
      });
      const price = tab.getAttribute('data-price');
      if (totalEl && price) totalEl.textContent = price;
      const variantId = tab.getAttribute('data-variant-id');
      // #region agent log
      cstxDbg('chopstx-home.js:selectTab', 'selectTab fired', {
        tabLabelText: tab.textContent.trim().slice(0, 40),
        tabVariantId: variantId,
        priorVariantInputValue: variantInput ? variantInput.value : null,
        willOverwrite: !!(variantInput && variantId),
      }, 'H4');
      // #endregion
      if (variantInput && variantId) variantInput.value = variantId;
      const qty = tab.getAttribute('data-quantity');
      if (quantityInput && qty) quantityInput.value = qty;
    }

    qtyTabs.forEach((tab) => tab.addEventListener('click', () => selectTab(tab)));
    selectTab(section.querySelector('[data-cstx-qty-tab].is-active') || qtyTabs[0]);

    const form = section.querySelector('[data-cstx-buy-form]');
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const variantInput = form.querySelector('[data-cstx-buy-variant]');
        const quantityInput = form.querySelector('[data-cstx-buy-quantity]');
        let variantId = variantInput && variantInput.value;
        const quantity = (quantityInput && quantityInput.value) || '1';
        // #region agent log
        cstxDbg('chopstx-home.js:submit:entry', 'add-to-cart form submit', {
          variantIdAtSubmit: variantId,
          quantity,
          activeTabVariantId: section.querySelector('[data-cstx-qty-tab].is-active')?.getAttribute('data-variant-id') || null,
        }, 'H5');
        // #endregion
        if (!variantId) {
          await resolveBuyVariant(section);
          variantId = variantInput && variantInput.value;
          // #region agent log
          cstxDbg('chopstx-home.js:submit:afterResolve', 'tried resolve fallback', {
            variantIdAfterResolve: variantId,
          }, 'H5');
          // #endregion
        }
        if (!variantId) {
          // #region agent log
          cstxDbg('chopstx-home.js:submit:noVariantAlert', 'showing missing-product alert', {}, 'H1');
          // #endregion
          alert('Link your ChopSTX product in the theme editor (ChopSTX — Buy section), or add a variant ID in section settings.');
          return;
        }

        const addUrl = section.getAttribute('data-cart-add-url') || '/cart/add.js';
        const submitBtn = form.querySelector('button[type="submit"]');
        const originalBtnHTML = submitBtn ? submitBtn.innerHTML : null;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding…';
        }

        try {
          const res = await fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');

          document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
            bubbles: true,
            detail: { response: data, sourceId: 'cstx-buy-form' },
          }));
          await renderCstxCartDrawer();
          openCstxCartDrawer();
        } catch (err) {
          alert(err.message || 'Could not add to cart. Check that the product is in stock.');
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (originalBtnHTML !== null) submitBtn.innerHTML = originalBtnHTML;
          }
        }
      });
    }
  });

  /* Sticky Add-to-Cart bar — reveals on scroll, hides when buy section is on screen. */
  (function initStickyAtc() {
    const bar = document.querySelector('[data-cstx-sticky-atc]');
    if (!bar) return;

    const isCartOrCheckout = /\/(cart|checkout)(\/|$|\?)/.test(window.location.pathname);
    if (isCartOrCheckout) return;

    const revealAfter = parseInt(bar.getAttribute('data-reveal-after'), 10) || 0;
    const hideOnBuy = bar.getAttribute('data-hide-on-buy') === '1';
    let buyOnScreen = false;

    function update() {
      const scrolledFarEnough = window.scrollY >= revealAfter;
      const shouldShow = scrolledFarEnough && !(hideOnBuy && buyOnScreen);
      if (shouldShow) {
        bar.removeAttribute('hidden');
        // double-rAF so the transition runs from translateY(100%) on first reveal
        requestAnimationFrame(() => requestAnimationFrame(() => bar.classList.add('is-visible')));
      } else {
        bar.classList.remove('is-visible');
      }
    }

    if (hideOnBuy) {
      const buy = document.querySelector('[data-cstx-buy]');
      if (buy && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              buyOnScreen = entry.isIntersecting;
            });
            update();
          },
          { threshold: 0.15 }
        );
        io.observe(buy);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    bar.addEventListener('transitionend', () => {
      if (!bar.classList.contains('is-visible')) {
        bar.setAttribute('hidden', '');
      }
    });

    const variantBtns = bar.querySelectorAll('[data-cstx-sticky-atc-variant-btn]');
    const variantInput = bar.querySelector('[data-cstx-sticky-atc-variant]');
    const priceEl = bar.querySelector('.cstx-sticky-atc__price');
    const thumbImg = bar.querySelector('.cstx-sticky-atc__thumb img');
    variantBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        variantBtns.forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        const id = btn.getAttribute('data-variant-id');
        const price = btn.getAttribute('data-price');
        const image = btn.getAttribute('data-image');
        if (variantInput && id) variantInput.value = id;
        if (priceEl && price) priceEl.textContent = price;
        if (thumbImg && image) thumbImg.src = image;
      });
    });

    const form = bar.querySelector('[data-cstx-sticky-atc-form]');
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const variantInput = form.querySelector('[data-cstx-sticky-atc-variant]');
        const variantId = variantInput && variantInput.value;
        if (!variantId) return;

        const addUrl = form.getAttribute('data-cart-add-url') || '/cart/add.js';
        const btn = form.querySelector('button[type="submit"]');
        const originalText = btn ? btn.textContent : null;
        if (btn) {
          btn.disabled = true;
          btn.classList.add('is-loading');
          btn.textContent = 'Adding…';
        }

        try {
          const res = await fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');

          document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
            bubbles: true,
            detail: { response: data, sourceId: 'cstx-sticky-atc' },
          }));
          if (typeof renderCstxCartDrawer === 'function') {
            await renderCstxCartDrawer();
            openCstxCartDrawer();
          }
        } catch (err) {
          alert(err.message || 'Could not add to cart. Check that the product is in stock.');
        } finally {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            if (originalText !== null) btn.textContent = originalText;
          }
        }
      });
    }
  })();

  /* Buy (single product) — pairs stepper + add to cart; one line item, reuses the cart drawer */
  document.querySelectorAll('[data-cstx-buy-single]').forEach((root) => {
    const qtyLabel = root.querySelector('[data-cstx-bs-qty-label]');
    const qtyInput = root.querySelector('[data-cstx-bs-qty]');
    const totalEl = root.querySelector('[data-cstx-bs-total]');
    const addBtn = root.querySelector('[data-cstx-bs-add]');
    const incBtn = root.querySelector('[data-cstx-bs-inc]');
    const decBtn = root.querySelector('[data-cstx-bs-dec]');
    const unit = parseInt(root.getAttribute('data-unit-price') || '0', 10);
    const variantId = root.getAttribute('data-variant-id');
    const addUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    let qty = 1;

    function sync() {
      if (qtyLabel) qtyLabel.textContent = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
      if (totalEl && unit) totalEl.textContent = cstxFormatMoney(unit * qty);
      if (decBtn) decBtn.disabled = qty <= 1;
    }

    if (incBtn) incBtn.addEventListener('click', (e) => { e.preventDefault(); qty = Math.min(qty + 1, 20); sync(); });
    if (decBtn) decBtn.addEventListener('click', (e) => { e.preventDefault(); if (qty > 1) { qty -= 1; sync(); } });

    // Gallery: thumbnail click swaps the main image
    const mainImg = root.querySelector('[data-cstx-bs-main]');
    root.querySelectorAll('[data-cstx-bs-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const full = thumb.getAttribute('data-full');
        if (full && mainImg) mainImg.src = full;
        root.querySelectorAll('[data-cstx-bs-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (!variantId) return;
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
        try {
          const res = await fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: qty }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          if (typeof renderCstxCartDrawer === 'function') {
            await renderCstxCartDrawer();
            if (typeof openCstxCartDrawer === 'function') openCstxCartDrawer();
          }
        } catch (err) {
          alert(err.message || 'Could not add to cart. Check that the product is in stock.');
        } finally {
          addBtn.disabled = false;
          addBtn.classList.remove('is-loading');
        }
      });
    }

    sync();
  });

  /* Social — inline video play on card (no popup) */
  document.querySelectorAll('[data-cstx-ugc-card]').forEach((card) => {
    const playBtn = card.querySelector('[data-cstx-ugc-play]');
    const video = card.querySelector('video.cstx-ugc-card__video');
    const poster = card.querySelector('.cstx-ugc-card__poster');
    const embed = card.querySelector('[data-cstx-ugc-embed]');
    if (!playBtn) return;

    function pauseOthers() {
      document.querySelectorAll('[data-cstx-ugc-card].is-playing').forEach((other) => {
        if (other === card) return;
        other.classList.remove('is-playing');
        const v = other.querySelector('video.cstx-ugc-card__video');
        if (v) {
          v.pause();
          v.muted = true;
          v.controls = false;
          try {
            v.currentTime = 0;
          } catch (_) {
            /* ignore */
          }
        }
      });
    }

    if (video) {
      video.setAttribute('playsinline', '');
      video.muted = true;
      if (video.preload !== 'auto') video.preload = 'auto';

      const primeFrame = () => {
        if (card.classList.contains('is-playing')) return;
        try {
          if (video.currentTime < 0.01) video.currentTime = 0.001;
        } catch (_) {
          /* ignore seek errors */
        }
      };

      video.addEventListener('loadeddata', primeFrame);
      if (video.readyState >= 2) primeFrame();
      else video.load();
    }

    playBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (video) {
        const playing = card.classList.contains('is-playing');
        if (playing) {
          video.pause();
          card.classList.remove('is-playing');
          video.controls = false;
          video.muted = true;
          try {
            video.currentTime = 0;
          } catch (_) {
            /* ignore */
          }
          return;
        }
        pauseOthers();
        card.classList.add('is-playing');
        video.muted = false;
        video.controls = true;
        video.play().catch(() => {
          video.muted = true;
          video.play();
        });
        return;
      }

      function withAutoplay(src) {
        if (!src) return src;
        if (src.indexOf('autoplay=1') !== -1) return src;
        const sep = src.indexOf('?') >= 0 ? '&' : '?';
        return src + sep + 'autoplay=1&muted=1';
      }

      const currentEmbed = embed || card.querySelector('[data-cstx-ugc-embed]');
      if (currentEmbed) {
        const playing = card.classList.contains('is-playing');
        if (playing) {
          card.classList.remove('is-playing');
          return;
        }
        pauseOthers();
        const parent = currentEmbed.parentNode;
        const fresh = currentEmbed.cloneNode(false);
        const src = currentEmbed.getAttribute('src');
        fresh.setAttribute('src', withAutoplay(src));
        fresh.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        fresh.setAttribute('allowfullscreen', '');
        currentEmbed.remove();
        parent.appendChild(fresh);
        card.classList.add('is-playing');
        return;
      }

      const lazySrc = card.getAttribute('data-embed-src');
      if (lazySrc) {
        pauseOthers();
        const thumb = card.querySelector('.cstx-ugc-card__thumb');
        if (thumb) {
          const iframe = document.createElement('iframe');
          iframe.className = 'cstx-ugc-card__embed';
          iframe.setAttribute('data-cstx-ugc-embed', '');
          iframe.setAttribute('src', withAutoplay(lazySrc));
          const captionEl = card.querySelector('.cstx-ugc-card__body p');
          iframe.setAttribute('title', (captionEl && captionEl.textContent.trim()) || 'Video');
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
          iframe.setAttribute('allowfullscreen', '');
          thumb.appendChild(iframe);
        }
        card.classList.add('is-playing');
      }
    });

    if (video) {
      video.addEventListener('ended', () => {
        card.classList.remove('is-playing');
        video.controls = false;
        video.muted = true;
        try {
          video.currentTime = 0;
        } catch (_) {
          /* ignore */
        }
      });
      video.addEventListener('pause', () => {
        if (!video.seeking && video.currentTime > 0 && !video.ended) return;
        if (video.paused && video.currentTime < 0.05) {
          card.classList.remove('is-playing');
          video.controls = false;
          video.muted = true;
        }
      });
    }
  });

  /* Social — desktop "solo play": starting one embed halts any other embed
     playing in the carousel. The embeds are cross-origin iframes (Instagram /
     TikTok), so we can't pause them directly. Instead we watch which embed the
     user is interacting with — clicking into an iframe makes it the document's
     activeElement — and reload the previously-active embed, which stops its
     playback. Mobile already behaves this way because iOS/Android only allow a
     single media element to play at once. */
  (function cstxEmbedSoloPlay() {
    function isEmbed(el) {
      return (
        el &&
        el.tagName === 'IFRAME' &&
        (el.classList.contains('cstx-ugc-card__embed') ||
          el.hasAttribute('data-cstx-ugc-embed'))
      );
    }
    if (!document.querySelector('iframe.cstx-ugc-card__embed, [data-cstx-ugc-embed]')) return;

    let activeEmbed = null;

    function resetEmbed(iframe) {
      if (!iframe || !iframe.isConnected) return;
      const base = (iframe.getAttribute('src') || '').split('?')[0];
      if (!base) return;
      // Reassigning src reloads the embed, halting any in-iframe playback.
      iframe.setAttribute('src', base);
      const card = iframe.closest('[data-cstx-ugc-card]');
      if (card) card.classList.remove('is-playing');
    }

    function onActiveChange() {
      const el = document.activeElement;
      if (!isEmbed(el) || el === activeEmbed) return;
      if (activeEmbed && activeEmbed !== el) resetEmbed(activeEmbed);
      activeEmbed = el;
      const card = el.closest('[data-cstx-ugc-card]');
      if (card) card.classList.add('is-playing');
    }

    // Clicking into a cross-origin iframe blurs the window; the poll also covers
    // iframe→iframe focus moves (where the window never regains focus, so no
    // second blur fires).
    window.addEventListener('blur', () => setTimeout(onActiveChange, 0));
    setInterval(onActiveChange, 350);
  })();

  /* FAQ accordion — scoped per section */
  document.querySelectorAll('[data-cstx-faq]').forEach((section) => {
    section.querySelectorAll('[data-cstx-faq-item]').forEach((item) => {
      const btn = item.querySelector('[data-cstx-faq-btn]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const wasOpen = item.classList.contains('is-open');
        section.querySelectorAll('[data-cstx-faq-item]').forEach((el) => {
          el.classList.remove('is-open');
          const icon = el.querySelector('[data-cstx-faq-icon]');
          if (icon) icon.textContent = '+';
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          const icon = item.querySelector('[data-cstx-faq-icon]');
          if (icon) icon.textContent = '−';
        }
      });
    });
  });

  /* Generic video player — play/stop and mute/unmute */
  const cstxPlayIconSVG = '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7L8 5z"/></svg>';
  const cstxStopIconSVG = '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="6" width="12" height="12"/></svg>';
  const cstxMutedIconSVG = '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16.5 12a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4zM4 9v6h4l5 5V4L8 9H4z"/><line x1="3" y1="3" x2="21" y2="21" stroke="currentColor" stroke-width="2"/></svg>';
  const cstxSoundIconSVG = '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4-.91 7-4.49 7-8.77 0-4.28-3-7.86-7-8.77z"/></svg>';
  document.querySelectorAll('[data-cstx-video]').forEach((video) => {
    const wrap = video.parentElement;
    if (!wrap) return;
    const playBtn = wrap.querySelector('[data-cstx-video-play]');
    const muteBtn = wrap.querySelector('[data-cstx-video-mute]');
    function syncPlay() {
      const playing = !video.paused && !video.ended;
      const icon = wrap.querySelector('[data-cstx-video-play-icon]');
      if (icon) {
        icon.outerHTML = playing
          ? cstxStopIconSVG.replace('<svg', '<svg data-cstx-video-play-icon class="cstx-vbtn-icon"')
          : cstxPlayIconSVG.replace('<svg', '<svg data-cstx-video-play-icon class="cstx-vbtn-icon"');
      }
      const label = wrap.querySelector('[data-cstx-video-play-label]');
      if (label) label.textContent = playing ? 'STOP' : 'PLAY';
      if (playBtn) playBtn.setAttribute('aria-label', playing ? 'Stop video' : 'Play video');
    }
    function syncMute() {
      const icon = wrap.querySelector('[data-cstx-video-mute-icon]');
      if (icon) {
        icon.outerHTML = video.muted
          ? cstxMutedIconSVG.replace('<svg', '<svg data-cstx-video-mute-icon class="cstx-vbtn-icon"')
          : cstxSoundIconSVG.replace('<svg', '<svg data-cstx-video-mute-icon class="cstx-vbtn-icon"');
      }
      const label = wrap.querySelector('[data-cstx-video-mute-label]');
      if (label) label.textContent = video.muted ? 'MUTED' : 'SOUND ON';
      if (muteBtn) muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }
    if (playBtn) {
      playBtn.addEventListener('click', () => {
        if (video.paused || video.ended) {
          video.play().catch(() => {});
        } else {
          video.pause();
          try { video.currentTime = 0; } catch (_) {}
        }
      });
    }
    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted && video.paused) video.play().catch(() => {});
        syncMute();
      });
    }
    video.addEventListener('play', syncPlay);
    video.addEventListener('pause', syncPlay);
    video.addEventListener('ended', syncPlay);
    video.addEventListener('volumechange', syncMute);
    syncPlay();
    syncMute();
  });

  /* Cart drawer — self-contained for chopstx layout */
  function cstxEscapeHtml(s) {
    const d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function cstxFormatMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }
  function ensureCstxCartDrawer() {
    if (document.querySelector('[data-cstx-cart-drawer]')) return;
    if (!document.getElementById('cstx-cart-drawer-styles')) {
      const styles = document.createElement('style');
      styles.id = 'cstx-cart-drawer-styles';
      styles.textContent = `
        .cstx-cart-drawer { position: fixed; inset: 0; z-index: 9999; }
        .cstx-cart-drawer[hidden] { display: none !important; }
        .cstx-cart-drawer__backdrop { position: absolute; inset: 0; background: rgba(0,0,0,0.6); animation: cstxCartFade 0.25s ease; }
        .cstx-cart-drawer__panel { position: absolute; top: 0; right: 0; bottom: 0; width: min(440px, 100%); background: #0a0a0a; color: #fff; display: flex; flex-direction: column; animation: cstxCartSlide 0.3s cubic-bezier(0.16, 1, 0.3, 1); font-family: 'Inter', system-ui, sans-serif; }
        @keyframes cstxCartFade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes cstxCartSlide { from { transform: translateX(100%); } to { transform: translateX(0); } }
        .cstx-cart-drawer__header { display: flex; align-items: center; justify-content: space-between; padding: 22px 24px; border-bottom: 1px solid rgba(255,255,255,0.1); flex-shrink: 0; }
        .cstx-cart-drawer__title { margin: 0; font-family: 'Barlow Condensed', sans-serif; font-size: 26px; font-weight: 900; letter-spacing: 0.04em; text-transform: uppercase; }
        .cstx-cart-drawer__close { background: none; border: none; color: inherit; cursor: pointer; font-size: 22px; padding: 6px 10px; line-height: 1; }
        .cstx-cart-drawer__close:hover { opacity: 0.7; }
        .cstx-cart-drawer__body { flex: 1; overflow-y: auto; padding: 8px 24px; }
        .cstx-cart-drawer__empty { text-align: center; opacity: 0.5; padding: 60px 0; margin: 0; font-size: 12px; letter-spacing: 0.14em; text-transform: uppercase; font-family: 'JetBrains Mono', monospace; }
        .cstx-cart-line { display: grid; grid-template-columns: 60px 1fr auto; gap: 14px; align-items: start; padding: 18px 0; border-bottom: 1px solid rgba(255,255,255,0.08); }
        .cstx-cart-line:last-child { border-bottom: none; }
        .cstx-cart-line__img { width: 60px; height: 60px; object-fit: cover; background: rgba(255,255,255,0.08); display: block; }
        .cstx-cart-line__title { font-weight: 600; font-size: 14px; margin: 0; line-height: 1.3; }
        .cstx-cart-line__variant { font-size: 10px; opacity: 0.55; letter-spacing: 0.12em; text-transform: uppercase; margin: 4px 0 0; font-family: 'JetBrains Mono', monospace; }
        .cstx-cart-line__qty { font-size: 11px; opacity: 0.7; margin-top: 8px; font-family: 'JetBrains Mono', monospace; }
        .cstx-cart-line__price { font-weight: 700; font-size: 14px; white-space: nowrap; }
        .cstx-cart-drawer__footer { padding: 20px 24px 28px; border-top: 1px solid rgba(255,255,255,0.1); flex-shrink: 0; }
        .cstx-cart-drawer__subtotal { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 16px; }
        .cstx-cart-drawer__subtotal-label { font-size: 11px; letter-spacing: 0.14em; opacity: 0.6; font-family: 'JetBrains Mono', monospace; }
        .cstx-cart-drawer__subtotal-value { font-family: 'Barlow Condensed', sans-serif; font-size: 24px; font-weight: 900; }
        .cstx-cart-drawer__checkout { display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; padding: 18px 24px; text-decoration: none; background: #FE0000; color: #fff; border: 2px solid #FE0000; font-weight: 700; font-size: 16px; letter-spacing: 0.02em; text-transform: uppercase; border-radius: 999px; font-family: 'Barlow Condensed', sans-serif; cursor: pointer; box-sizing: border-box; }
        .cstx-cart-drawer__checkout:hover { opacity: 0.92; }
      `;
      document.head.appendChild(styles);
    }
    const drawer = document.createElement('div');
    drawer.className = 'cstx-cart-drawer';
    drawer.setAttribute('data-cstx-cart-drawer', '');
    drawer.setAttribute('hidden', '');
    drawer.innerHTML = `
      <div class="cstx-cart-drawer__backdrop" data-cstx-cart-close></div>
      <aside class="cstx-cart-drawer__panel" role="dialog" aria-modal="true" aria-label="Your cart">
        <header class="cstx-cart-drawer__header">
          <h2 class="cstx-cart-drawer__title">Your cart</h2>
          <button type="button" class="cstx-cart-drawer__close" data-cstx-cart-close aria-label="Close cart">&times;</button>
        </header>
        <div class="cstx-cart-drawer__body" data-cstx-cart-body>
          <p class="cstx-cart-drawer__empty">Your cart is empty.</p>
        </div>
        <footer class="cstx-cart-drawer__footer" data-cstx-cart-footer hidden>
          <div class="cstx-cart-drawer__subtotal">
            <span class="cstx-cart-drawer__subtotal-label">Subtotal</span>
            <span class="cstx-cart-drawer__subtotal-value" data-cstx-cart-subtotal>$0.00</span>
          </div>
          <a href="/checkout" class="cstx-cart-drawer__checkout">Checkout &rarr;</a>
        </footer>
      </aside>
    `;
    document.body.appendChild(drawer);
  }
  function openCstxCartDrawer() {
    ensureCstxCartDrawer();
    const drawer = document.querySelector('[data-cstx-cart-drawer]');
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }
  function closeCstxCartDrawer() {
    const drawer = document.querySelector('[data-cstx-cart-drawer]');
    if (!drawer) return;
    drawer.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
  async function renderCstxCartDrawer() {
    ensureCstxCartDrawer();
    const body = document.querySelector('[data-cstx-cart-body]');
    const footer = document.querySelector('[data-cstx-cart-footer]');
    const subtotalEl = document.querySelector('[data-cstx-cart-subtotal]');
    if (!body) return;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<p class="cstx-cart-drawer__empty">Your cart is empty.</p>';
        if (footer) footer.setAttribute('hidden', '');
        updateCstxCartCount(0);
        return;
      }
      body.innerHTML = cart.items.map((item) => {
        const img = item.image
          ? `<img class="cstx-cart-line__img" src="${cstxEscapeHtml(item.image)}" alt="" width="60" height="60">`
          : '<div class="cstx-cart-line__img"></div>';
        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="cstx-cart-line__variant">${cstxEscapeHtml(item.variant_title)}</p>`
          : '';
        const key = cstxEscapeHtml(item.key);
        return `
          <div class="cstx-cart-line" data-cstx-cart-line data-key="${key}">
            ${img}
            <div>
              <p class="cstx-cart-line__title">${cstxEscapeHtml(item.product_title)}</p>
              ${variant}
              <div class="cstx-cart-line__qty" data-cstx-qty-stepper>
                <button type="button" class="cstx-cart-line__qty-btn" data-cstx-qty-dec aria-label="Decrease quantity">&minus;</button>
                <span class="cstx-cart-line__qty-value" data-cstx-qty-value>${item.quantity}</span>
                <button type="button" class="cstx-cart-line__qty-btn" data-cstx-qty-inc aria-label="Increase quantity">+</button>
              </div>
            </div>
            <span class="cstx-cart-line__price">${cstxFormatMoney(item.final_line_price)}</span>
          </div>
        `;
      }).join('');
      if (footer) footer.removeAttribute('hidden');
      if (subtotalEl) subtotalEl.textContent = cstxFormatMoney(cart.total_price);
      updateCstxCartCount(cart.item_count);
    } catch (e) {
      body.innerHTML = '<p class="cstx-cart-drawer__empty">Could not load cart.</p>';
    }
  }

  function updateCstxCartCount(count) {
    document.querySelectorAll('.cstx-nav__cart').forEach((el) => {
      el.textContent = el.textContent.replace(/\(\d+\)/, `(${count})`);
    });
  }

  async function changeCstxCartLine(key, quantity) {
    const line = document.querySelector(`[data-cstx-cart-line][data-key="${CSS.escape(key)}"]`);
    if (line) line.classList.add('is-updating');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) throw new Error('Could not update cart');
      await res.json();
      await renderCstxCartDrawer();
    } catch (e) {
      if (line) line.classList.remove('is-updating');
    }
  }
  function shouldOpenCartDrawerOnAdd() {
    return window.theme?.settings?.openDrawerOnAddToCart !== false;
  }

  function handleOpenCstxCartDrawer(e) {
    if (e?.preventDefault) e.preventDefault();
    renderCstxCartDrawer().then(openCstxCartDrawer);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cstx-cart-close]')) {
      closeCstxCartDrawer();
      return;
    }
    if (e.target.closest('[data-cart-drawer-toggle]')) {
      e.preventDefault();
      e.stopPropagation();
      handleOpenCstxCartDrawer();
      return;
    }
    const decBtn = e.target.closest('[data-cstx-qty-dec]');
    const incBtn = e.target.closest('[data-cstx-qty-inc]');
    if (decBtn || incBtn) {
      e.preventDefault();
      e.stopPropagation();
      const line = (decBtn || incBtn).closest('[data-cstx-cart-line]');
      if (!line) return;
      const key = line.getAttribute('data-key');
      const valueEl = line.querySelector('[data-cstx-qty-value]');
      const current = parseInt(valueEl?.textContent || '0', 10) || 0;
      const next = decBtn ? Math.max(0, current - 1) : current + 1;
      if (valueEl) valueEl.textContent = next;
      changeCstxCartLine(key, next);
      return;
    }
    const cartLink = e.target.closest('.cstx-nav__cart');
    if (cartLink) {
      handleOpenCstxCartDrawer(e);
    }
  }, true);

  document.body.addEventListener('baseline:cart:afteradditem', () => {
    if (!shouldOpenCartDrawerOnAdd()) return;
    renderCstxCartDrawer().then(openCstxCartDrawer);
  });

  document.addEventListener('theme:open:cart-drawer', () => {
    renderCstxCartDrawer().then(openCstxCartDrawer);
  });

  document.addEventListener('theme:close:cart-drawer', closeCstxCartDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const drawer = document.querySelector('[data-cstx-cart-drawer]');
      if (drawer && !drawer.hasAttribute('hidden')) closeCstxCartDrawer();
    }
  });
})();
